export default __webpack_public_path__ + "static/media/share-icon-white.1d325368.svg";